import React from 'react';
import { Helmet } from 'react-helmet';
import { Switch, Route, Redirect } from 'react-router-dom';

// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import SchemasWithoutEventTypeIdExistGate from 'components/SchemasWithoutEventTypeIdExistGate';

import Job from './scenes/Job';
import Planner from './scenes/Planner';
import Settings from './scenes/Settings';

const { REACT_APP_PROJECT_NAME } = process.env;

const Jobs = (): React.ReactElement => (
    <ErrorBoundary namespace="Jobs" FallbackComponent={<ErrorBoundaryAlert />}>
        <Helmet>
            <title>Jobs - {REACT_APP_PROJECT_NAME}</title>
        </Helmet>
        <SchemasWithoutEventTypeIdExistGate
            FallbackComponent={<Redirect to="/organization/workforce" />}
        >
            <Switch>
                <Redirect
                    exact
                    from="/organization/jobs"
                    to="/organization/jobs/planner"
                />
                <Route
                    exact
                    path="/organization/jobs/planner"
                    component={Planner}
                />
                <Route
                    exact
                    path="/organization/jobs/settings"
                    component={Settings}
                />
                <Route
                    exact
                    path="/organization/jobs/:documentSetId"
                    component={Job}
                />
                <Redirect
                    from="/organization/jobs/*"
                    to="/organization/jobs/planner"
                />
            </Switch>
        </SchemasWithoutEventTypeIdExistGate>
    </ErrorBoundary>
);

export default Jobs;
